import React, { useState } from 'react';

export default function ThinkyIOTUserManagement({ onBack }) {
  const [tenants] = useState([
    { id: 1, name: 'Tenant A', users: 12, status: 'Active' },
    { id: 2, name: 'Tenant B', users: 8, status: 'Inactive' },
    { id: 3, name: 'Tenant C', users: 20, status: 'Active' },
  ]);

  const [users] = useState([
    { id: 1, name: 'Alice', role: 'Admin', tenant: 'Tenant A', status: 'Active' },
    { id: 2, name: 'Bob', role: 'Operator', tenant: 'Tenant A', status: 'Active' },
    { id: 3, name: 'Charlie', role: 'Viewer', tenant: 'Tenant B', status: 'Inactive' },
    { id: 4, name: 'David', role: 'Operator', tenant: 'Tenant C', status: 'Active' },
  ]);

  return (
    <div className="min-h-screen bg-black text-white px-4 py-8">
      <button onClick={onBack} className="mb-6 px-4 py-2 bg-blue-600 rounded hover:bg-blue-500 w-24">&larr; Back</button>
      <h1 className="text-lg lg:text-xl font-bold mb-6">Multi-Tenancy & User Management</h1>

      <section className="mb-8">
        <h2 className="text-lg font-semibold mb-3">Tenants</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {tenants.map(tenant => (
            <div key={tenant.id} className="bg-neutral-900 border border-neutral-800 rounded-2xl p-5 shadow-sm">
              <h3 className="text-lg font-semibold mb-2">{tenant.name}</h3>
              <p>Users: <span className="font-medium">{tenant.users}</span></p>
              <p>Status: <span className={`${tenant.status==='Active' ? 'text-green-400' : 'text-red-500'} font-semibold`}>{tenant.status}</span></p>
            </div>
          ))}
        </div>
      </section>

      <section>
        <h2 className="text-lg font-semibold mb-3">Users</h2>
        <div className="bg-neutral-900 border border-neutral-800 rounded-2xl p-5 shadow-sm max-h-80 overflow-y-auto">
          <table className="w-full text-left text-sm">
            <thead>
              <tr>
                <th className="px-2 py-1">Name</th>
                <th className="px-2 py-1">Role</th>
                <th className="px-2 py-1">Tenant</th>
                <th className="px-2 py-1">Status</th>
              </tr>
            </thead>
            <tbody>
              {users.map(user => (
                <tr key={user.id} className="border-t border-neutral-800">
                  <td className="px-2 py-1">{user.name}</td>
                  <td className="px-2 py-1">{user.role}</td>
                  <td className="px-2 py-1">{user.tenant}</td>
                  <td className={`px-2 py-1 ${user.status==='Active' ? 'text-green-400' : 'text-red-500'}`}>{user.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
